import { useQuery } from '@tanstack/react-query';
import { IGetRecentProfessionalsParams } from '../recentProfessionalsApi';
import { recentProfessionalsService } from '../recentProfessionalsService';
import { IRecentProfessional } from '../recentProfessionalsTypes';

type TUseRecentProfessionalsParams = IGetRecentProfessionalsParams & {
  enabled: boolean;
};

export function useRecentProfessionals(params: TUseRecentProfessionalsParams) {
  return useQuery<IRecentProfessional[]>({
    queryKey: ['recent-professionals', params],
    queryFn: () => recentProfessionalsService.getRecentProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
}
